import React from 'react';
import Button from '@material-ui/core/Button';
import ModalHead from './ModalHead';
import Typography from '@material-ui/core/Typography';
import CopyrightIcon from '@material-ui/icons/Copyright';
import {Styles} from './Styles';

interface Props {
    close():void,
}

const Guide = (props:Props)=> {
    const classes = Styles.base();

    return (
        <div id="confirm" className={classes.modalRoot}>
            <ModalHead close={props.close}/>
            <Typography variant="subtitle1" className={classes.subtitle1}>このゲームは？</Typography>
            <div style={{marginBottom:"2em"}}>
                基本的には「神経衰弱」です。神経衰弱と違うのは、同じカードを探すのではなく両思いのカードを探すところです。
            </div>
            <Typography variant="subtitle1" className={classes.subtitle1}>遊び方</Typography>
            <div style={{marginBottom:"2em"}}>
                鍵のかかった部屋を開けて、両思いの少女を探して下さい。時には三角関係になっているケースもあります。片思いを発見したら、さらにもう一部屋開けて三角関係を見つけて下さい。<br/>
            </div>
            <Typography variant="subtitle1" className={classes.subtitle1}>終わり方</Typography>
            <div style={{marginBottom:"2em"}}>
                最後に一人だけ残ったらゲーム終了です。<br/>
            </div>
            <Typography variant="subtitle1" className={classes.subtitle1}>気を付けること</Typography>
            <div style={{marginBottom:"2em"}}>
                ・キャラクター作成の際に入力した内容は、ほかのプレイヤーの目に触れます。他人に見せられないような恥ずかしいことは書かないようにしましょう。<br/>
                ・キャラクターの画像は「no photo」になりますが異常ではありません。今回は顔画像が用意できませんでした。<br/>
                ・エンディングは一種類だけです。マルチエンディングではありません。<br/>
            </div>
            <Typography variant="subtitle1" className={classes.subtitle1}>クレジット</Typography>
            <div style={{marginBottom:"2em"}}>
                ・このゲームはレトロインクが作成しました。<br/>
                ・レトロインクは、プレイヤーがこのゲームに入力したテキストを、このゲームおよび派生する関連コンテンツ内において自由に使用する権利を有します。<br/>
            </div>
            <div style={{textAlign:"center",marginBottom:"4em"}}>
                24Girls<br/>
                ver.20190801<br/>
                <br/>
                <span className={classes.withIcon} ><CopyrightIcon/>レトロインク　2019</span><br/>
                <a href="https://goisagi.retro-ink.com/" target="_blank" className="tw" rel="noopener noreferrer" style={{textDecoration:"none"}}>https://goisagi.retro-ink.com/</a>
            </div>
            <Button variant="outlined" color="default" style={{width:"100%",marginBottom:"2em"}} onClick={props.close}>閉じる</Button>
        </div>
    );
}

export default Guide;
